export default "__VITE_ASSET__86dbe818__"